import { giphyDarkestGrey, giphyLightestGrey } from '@giphy/colors'
import styled from 'styled-components'
import iconButton from '../controls/icon-button'

export const Container = styled.div<{ hasSticker: boolean }>`
    background: ${giphyDarkestGrey};
    border-radius: 6px;
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    padding: ${({ hasSticker }) => (hasSticker ? '50px' : '30px 50px')};
    position: relative;
    text-align: center;
`

export const Description = styled.p`
    line-height: 1.4;
    margin: 0 auto 1em;
    text-align: inherit;
`

export const Title = styled.h2`
    color: #fff;
    font-family: 'nexablack';
    font-size: 1.3em;
    font-weight: normal;
    margin-bottom: 0.7em;
`

export const Header = styled.div`
    ${Title}:last-child,
    ${Description}:last-child {
        margin-bottom: 1.5em;
    }
`

export const Sticker = styled.img`
    height: 80px;
    left: 50%;
    margin-left: -60px;
    object-fit: contain;
    pointer-events: none;
    position: absolute;
    top: -40px;
    width: 120px;
`

export const CloseButton = styled(iconButton)`
    position: absolute;
    right: 0;
    top: 0;
`
